export function addRule(add, field, message, number) {
    switch (field) {
        case 'string':
            message ? add = add.string(message) : add = add.string();
            break;
        case 'email':
            message ? add = add.email(message) : add = add.email();
            break;
        case 'number':
            message ? add = add.number(message) : add = add.number();
            break;
        case 'required':
            message ? add = add.required(message) : add = add.required();
            break;
        case 'max':
            message ? add = add.max(field + number, message) : add = add.max(field + number);
            break;
        case 'min':
            message ? add = add.min(field + number, message) : add = add.min(field + number);
            break;
    }
    return add;
}

export function isRequired(rules) {
    for (let i in rules) {
        let rule = rules[i];
        if (rule.name === 'required') {
            return true;
        }
    }

    return false;
}
